import { render, staticRenderFns } from "./AttendanceAdjustment.vue?vue&type=template&id=3054c648"
import script from "./AttendanceAdjustment.vue?vue&type=script&lang=js"
export * from "./AttendanceAdjustment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports